'use client'

import { Pill } from '@repo/ui/Pill'
import type { SubmissionStatus } from '../types'

export type SubmissionStatusPillProps = {
  status: SubmissionStatus
}

const LABELS: Record<SubmissionStatus, string> = {
  Success: 'Success',
  Failed: 'Failed'
}

// Success/failure signal — same white-on-solid-colour treatment MatterStatusPill uses
// for its 'Completed' (success.main) state; Failed takes the equivalent error.main.
const COLOURS: Record<SubmissionStatus, { color: string; backgroundColor: string }> = {
  Success: { color: 'white', backgroundColor: 'success.main' },
  Failed: { color: 'white', backgroundColor: 'error.main' }
}

export const SubmissionStatusPill = ({ status }: SubmissionStatusPillProps) => {
  const { color, backgroundColor } = COLOURS[status]

  return (
    <div data-testid="SubmissionStatusPill">
      <Pill label={LABELS[status]} color={color} backgroundColor={backgroundColor} />
    </div>
  )
}
